import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
            <div className="col-md-7">
            <div className="pq-section pq-style-1 text-center">
               <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
            </div>
            
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "What causes mouth ulcers?", answer: "Mouth ulcers may occur due to stress, vitamin deficiencies, spicy food, minor injuries, acidity, or low immunity. Sometimes hormonal changes, allergies, or infections can trigger repeated ulcers. A proper medical checkup helps identify the cause and ensures effective, long-term relief." },
                  { question: "How are mouth ulcers treated?", answer: "Treatment includes soothing gels, antiseptic mouthwash, pain-relief medicines, vitamin supplements, and diet changes. For severe or recurrent ulcers, doctors may prescribe targeted medication. Identifying triggers like acidity, stress, or deficiencies helps prevent frequent recurrence." },
                  { question: "When should I consult a doctor?", answer: "You should see a doctor if the ulcer lasts more than 10–14 days, keeps coming back, is very painful, or interferes with eating or speaking. If ulcers are accompanied by fever or swelling, medical evaluation is needed to rule out infection or other underlying conditions." },
                  {question: "Are mouth ulcers contagious?", answer: "Most common mouth ulcers are not contagious. They usually result from irritation, stress, or deficiencies. However, ulcers caused by viral infections like Herpes can spread. A doctor can diagnose the type of ulcer and advise the correct treatment to avoid complications."},
                  {question: "How can I prevent mouth ulcers?", answer: "Maintain good oral hygiene, stay hydrated, reduce spicy foods, manage stress, and include vitamins like B12 and folic acid in your diet. Avoid accidental cheek bites and use a soft-bristle toothbrush. If ulcers are frequent, a medical checkup can help identify hidden causes."}
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            </div>
            <div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                     <iframe width="100%" height="315" src="https://www.youtube.com/embed/1NxdEdeq32A?si=cU__zoo8IVALmY-E" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  <div class="p-3"><h5 class="text-success mb-0">Mouth Ulcers (Aphthous ulcer) | मुँह के छाले एफ़्थस अल्सर| Dr. Major Rajesh Bhardwaj</h5></div>
          </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
